"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const lodash_1 = require("lodash");
const classnames_1 = __importDefault(require("classnames"));
const react_redux_1 = require("react-redux");
const mui_1 = require("tss-react/mui");
const react_router_dom_1 = require("react-router-dom");
const react_use_1 = require("react-use");
const Slide_1 = __importDefault(require("@mui/material/Slide"));
const AppBar_1 = __importDefault(require("@mui/material/AppBar"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const Toolbar_1 = __importDefault(require("@mui/material/Toolbar"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const ButtonBase_1 = __importDefault(require("@mui/material/ButtonBase"));
const core_1 = require("companion-app-components/utils/core");
const feature_flags_1 = require("companion-app-components/flux/feature-flags");
const entitlements_1 = require("companion-app-components/flux/entitlements");
const accountGroupsSelectors_1 = require("companion-app-components/flux/account-groups/accountGroupsSelectors");
const accountsSelectors_1 = require("companion-app-components/flux/accounts/accountsSelectors");
const GuidedTooltip_1 = __importDefault(require("components/GuidedTooltip"));
const paths_1 = require("containers/App/paths");
const useQPreferences_1 = __importDefault(require("components/QPreferences/useQPreferences"));
const utils_1 = require("containers/BudgetsV2/utils");
const EntitySelectNavButton_1 = __importDefault(require("components/EntitySelectNavButton"));
const constants_1 = require("data/accounts/constants");
const thewhiteq_svg_1 = __importDefault(require("assets/thewhiteq.svg"));
const help_inline_svg_1 = __importDefault(require("assets/nav-menu/help.inline.svg"));
const MoreButton_1 = __importDefault(require("./MoreButton"));
const ProfileMenu_1 = __importDefault(require("./ProfileMenu"));
const RefreshButton_1 = __importDefault(require("./RefreshButton"));
const MainNavItem_1 = require("./MainNavItem");
const FeedbackButton_1 = __importDefault(require("./FeedbackButton"));
const QCardToggleButton_1 = __importDefault(require("./QCardToggleButton"));
const HelpSupportButton_1 = __importDefault(require("./HelpSupportButton"));
const styles_1 = require("./styles");
const useStyle = (0, mui_1.makeStyles)()(styles_1.styles);
const Header = ({ selected, onMouseEnter, onMouseLeave, showRefreshIcon, qCardsOn, hide, selectedAccountNodes, onQCardsClick }) => {
    const [canOpen, setCanOpen] = React.useState(true);
    const [showNewRuleTooltip, setShowNewRuleTooltip] = React.useState(false);
    const [isSmallScreen, setIsSmallScreen] = React.useState(window.innerHeight <= 768);
    const location = (0, react_router_dom_1.useLocation)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const tier = (0, react_redux_1.useSelector)(entitlements_1.entitlementsSelectors.getTopTierEntitlement);
    const authenticated = (0, react_redux_1.useSelector)(entitlements_1.entitlementsSelectors.isAuthenticated);
    const featureFlags = (0, react_redux_1.useSelector)(feature_flags_1.featureFlagsSelectors.getFeatureFlags);
    const showIntercom = (0, react_redux_1.useSelector)((state) => feature_flags_1.featureFlagsSelectors.getFeatureFlag(state, 'intercom'));
    const isEntityShareEnableUser = (0, react_redux_1.useSelector)(accountGroupsSelectors_1.isEntityShareUser);
    const accountTypes = (0, react_redux_1.useSelector)(accountsSelectors_1.getAccountTypes);
    let isOnlyInvestment = false;
    let isOnlyBank = false;
    if (isEntityShareEnableUser) {
        isOnlyInvestment = accountTypes.every((type) => ['INVESTMENT'].includes(type));
        isOnlyBank = accountTypes.every((type) => constants_1.BANKING_ACCOUNT_TYPES.includes(type));
    }
    const { classes, theme } = useStyle();
    const { sharedPreferences, datasetPreferences, setDatasetPreference } = (0, useQPreferences_1.default)();
    const settingsPageNavRef = React.useRef(null);
    const onWindowResize = () => setIsSmallScreen(window.innerHeight <= 768);
    (0, react_use_1.useEffectOnce)(() => window.addEventListener('resize', (0, lodash_1.throttle)(onWindowResize, 500)));
    (0, react_use_1.useUnmount)(() => window.removeEventListener('resize', (0, lodash_1.throttle)(onWindowResize, 500)));
    const drawerCannotOpen = () => setCanOpen(false);
    const handleTracking = (pathClicked) => {
        if (pathClicked === '/budgets') {
            const detailsToTrack = (0, utils_1.extractDetailsForTracker)(sharedPreferences);
            core_1.tracker.track(core_1.tracker.events.clickBudgetMenu, detailsToTrack);
        }
    };
    const getSettingsPage = () => {
        const nav = paths_1.featurePages.find((x) => x.path === '/settings');
        if (nav && (!nav.featureFlag || featureFlags.get(nav.featureFlag))) {
            return (<>
          <MainNavItem_1.MainNavItem key="nav-item-settings" nav={nav} iconRef={settingsPageNavRef} selected={selected} classes={classes} iconSize={theme.components.navigation.iconSize} displayNode={selectedAccountNodes && nav.preserveDisplayNode ?
                    selectedAccountNodes[nav.path] : 'all'} closeHeader={drawerCannotOpen} handleTracking={handleTracking}/>
          <GuidedTooltip_1.default anchorEl={settingsPageNavRef.current} open={showNewRuleTooltip} placement={'right'} title="Rule created" body="Payee rename and category rules can be edited or deleted in Settings." cancelLabel="don't show again" continueLabel="got it" onCancel={() => {
                    setShowNewRuleTooltip(false);
                    setDatasetPreference({ dontShowNewRuleTooltip: true });
                }} onContinue={() => {
                    setShowNewRuleTooltip(false);
                }} modifiers={{
                    offset: {
                        enabled: true,
                        offset: '0,20',
                    },
                }}/>
        </>);
        }
        return null;
    };
    const drawerCanOpen = () => setCanOpen(true);
    const getNavbarStyle = () => (0, classnames_1.default)(classes.navbar, !canOpen ? 'expand' : 'closed');
    const onCloseHeader = () => {
        drawerCanOpen();
        onMouseLeave();
    };
    React.useEffect(() => {
        const preventedRoutesForEntitySharedUsers = ['/budgets', '/bills-and-income'];
        if (isEntityShareEnableUser && preventedRoutesForEntitySharedUsers.includes(location.pathname)) {
            navigate('/oops');
        }
    }, [isEntityShareEnableUser, location, navigate]);
    return (<Slide_1.default in={authenticated} direction="right">
      <AppBar_1.default id="application-header-bar" elevation={0} position="fixed" className={hide ? classes.staticNav : getNavbarStyle()} onMouseLeave={drawerCanOpen} onMouseEnter={drawerCannotOpen}>
        <div className={classes.appDiv}>
          <div className={classes.logoSection} style={{ cursor: hide ? 'default' : undefined }}>
            {/* @ts-expect-error: No overload matches this call. */}
            <Button_1.default onClick={drawerCannotOpen} id="logo-nav" classes={{
            root: classes.rootButton,
            text: classes.textButton,
        }} component={React.forwardRef((prop, ref) => hide ? // eslint-disable-line react/no-unstable-nested-components
            <div {...prop} ref={ref}/>
            :
                <react_router_dom_1.NavLink {...prop} 
                // @ts-expect-error: Property 'innerRef' does not exist on type 'IntrinsicAttributes & NavLinkProps & RefAttributes<HTMLAnchorElement>'
                innerRef={ref}/>)} to="/" style={{ cursor: hide ? 'default' : undefined }}>
              <img src={thewhiteq_svg_1.default} style={{ filter: 'grayscale(1)', height: 32 }} alt="quicken logo, click to go home"/>
            </Button_1.default>
          </div>
          <div className={classes.appBarContainer} onMouseEnter={hide ? undefined : onMouseEnter} onMouseLeave={hide ? undefined : onMouseLeave}>
            <Toolbar_1.default classes={{ root: classes.toolbar }}>
              <div className={classes.betaLabel}>
                {`${datasetPreferences.kioskmode ? '*' : ''}`}
              </div>
              {!hide &&
            <div className={classes.navItemsHolder}>
                    <div>
                      <div className={classes.navPopover}>
                        <EntitySelectNavButton_1.default classes={classes} iconSize={theme.components.navigation.iconSize} canOpenSubMenu={!canOpen} closeHeader={onCloseHeader}/>
                        {paths_1.navMainOrder.map((navKey) => {
                    const nav = paths_1.featurePages.find((x) => x.path === `/${navKey}`);
                    if (nav && (!nav.featureFlag || featureFlags.get(nav.featureFlag)) &&
                        (!nav.hideOnTiers.length || !nav.hideOnTiers.includes(tier === null || tier === void 0 ? void 0 : tier.id)) &&
                        (!nav.hideOnEntityShare || !isEntityShareEnableUser) &&
                        (!nav.hideOnEntityShareOnlyBanking || !isOnlyBank) &&
                        (!nav.hideOnEntityShareOnlyInvestment || !isOnlyInvestment)) {
                        return (<MainNavItem_1.MainNavItem key={`nav-item-${nav.path}`} nav={nav} selected={selected} classes={classes} canOpenSubMenu={!canOpen} iconSize={theme.components.navigation.iconSize} displayNode={selectedAccountNodes && nav.preserveDisplayNode ?
                                selectedAccountNodes[nav.path] : 'all'} closeHeader={onCloseHeader} handleTracking={handleTracking}/>);
                    }
                    return null;
                })}
                      </div>
                    </div>
                  </div>}
            </Toolbar_1.default>
          </div>
          <div className={classes.navBottomSection}>
            <div className={classes.navButtonBottom}>
              {onQCardsClick && !isEntityShareEnableUser &&
            <QCardToggleButton_1.default size={theme.components.navigation.iconSize} qCardsOn={qCardsOn} onClick={onQCardsClick} closeHeader={drawerCannotOpen}/>}
              {!isSmallScreen && (<HelpSupportButton_1.default classes={classes} selected={selected} iconSize={theme.components.navigation.iconSize} settingsPageNavRef={settingsPageNavRef} canOpenSubMenu={!canOpen} closeHeader={onCloseHeader} handleTracking={handleTracking}/>)}

              {
        ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        <>
                  <MainNavItem_1.MainNavItem key="nav-item-docs" closeHeader={drawerCannotOpen} nav={paths_1.featurePages.find((x) => x.path === '/docs')} selected={selected} classes={classes} iconSize={theme.components.navigation.iconSize} handleTracking={handleTracking}/>
                  <div style={{ paddingTop: 24 }}/>
                </>
        /////////////////////////
        }

              {!isSmallScreen && showRefreshIcon && !hide &&
            <RefreshButton_1.default 
            // @ts-expect-error: Property 'id' does not exist on type 'IntrinsicAttributes
            id="sync-arrow" closeHeader={drawerCannotOpen} size={theme.components.navigation.iconSize}/>}

              {!isSmallScreen && !hide && getSettingsPage()}

              {isSmallScreen && <MoreButton_1.default classes={classes} showRefreshIcon={showRefreshIcon} hide={hide} featureFlags={featureFlags}/>}
              {showIntercom &&
            <ButtonBase_1.default id="intercom-launcher" className={classes.navMenuItemSupport}>
                    <help_inline_svg_1.default />
                    <Typography_1.default className={classes.navText}>
                      Help Center
                    </Typography_1.default>
                  </ButtonBase_1.default>}
              <FeedbackButton_1.default classes={classes}/>
              <ProfileMenu_1.default classes={classes}/>
            </div>
          </div>
        </div>
      </AppBar_1.default>
    </Slide_1.default>);
};
exports.default = Header;
